import { createFileRoute } from '@tanstack/react-router'
import { Nav } from '@/components/landing/nav'
import { Hero } from '@/components/landing/hero'
import { Problem } from '@/components/landing/problem'
import { Solution } from '@/components/landing/solution'
import { Family } from '@/components/landing/family'
import { Capabilities } from '@/components/landing/capabilities'
import { Ontext } from '@/components/landing/ontext'
import { Sentinel } from '@/components/landing/sentinel'
import { Kernel } from '@/components/landing/kernel'
import { Kaavya } from '@/components/landing/kaavya'
import { About } from '@/components/landing/about'
import { CTASection } from '@/components/landing/cta-section'
import { Footer } from '@/components/landing/footer'

export const Route = createFileRoute('/_public/')({
  component: Index,
})

function Index() {
  return (
    <div
      style={{
        background: '#0A0F1F',
        minHeight: '100vh',
        color: '#ffffff',
        overflowX: 'hidden',
      }}
    >
      <Nav />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <Family />
        <Capabilities />
        <Ontext />
        <Sentinel />
        <Kernel />
        <Kaavya />
        <About />
        <CTASection />
      </main>
      <Footer />
    </div>
  )
}
